import { action } from 'mobx';
import _get from 'lodash/get';
import { handlerTokenExpired, headerUserId, authHeader } from 'helpers/serviceHelpers';
import { axiosInstace } from 'service';

export class User {
  @action
  userAll = async () => {
    try {
      const token = authHeader();
      const requestOptions = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          ...token
        }
      };

      const response = await axiosInstace.post("/user/getCard/", {}, requestOptions)

      localStorage.setItem("userId", JSON.stringify(response.data?.id));
      localStorage.setItem("userEmail", JSON.stringify(response.data?.email));
      localStorage.setItem("userData", JSON.stringify(response.data));

      return { data: response.data, status: response.status, error: false }
    } catch (error) {
      if (error.response.status === 401) {
        handlerTokenExpired();
      } else {
        return { status: _get(error.response, "status", ""), message: _get(error.response.data, "message", "") };
      };
    };
  };

  @action
  userProfile = async () => {
    try {
      const token = authHeader();
      const userId = headerUserId();
      const requestOptions = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          ...token
        }
      };

      const response = await axiosInstace.get(`/user/${userId.id}/`, requestOptions)

      return { data: response.data, status: response.status, error: false }
    } catch (error) {
      if (error.response.status === 401) {
        handlerTokenExpired();
      } else {
        return { status: _get(error.response, "status", ""), message: _get(error.response.data, "message", "") };
      };
    };
  };

  @action
  userValidadePassword = async (body) => {
    try {
      const token = authHeader();

      const requestOptions = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          ...token
        }
      };

      const response = await axiosInstace.post("/auth/checkPassword/", body, requestOptions)

      return { data: response.data, status: response.status, error: false }
    } catch (error) {
      return { status: _get(error.response, "status", ""), message: _get(error.response.data, "message", "") };
    };
  };

  @action
  userUpdateProfile = async (id, body) => {
    try {
      const token = authHeader();

      const requestOptions = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          ...token
        }
      };

      const response = await axiosInstace.put(`/user/${id}/`, body, requestOptions)

      return { data: response.data, status: response.status, error: false }
    } catch (error) {
      if (error.response.status === 401) {
        handlerTokenExpired();
      } else {
        return { status: _get(error.response, "status", ""), message: _get(error.response.data, "message", "") };
      };
    };
  };

  @action
  userDeleteProfile = async (body) => {
    try {
      const token = authHeader();
      const userId = headerUserId();
      const requestOptions = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          ...token
        }
      };

      const response = await axiosInstace.post(`/user/delete/${userId.id}/`, body, requestOptions)

      return { data: response.data, status: response.status, error: false }
    } catch (error) {
      if (error.response.status === 401) {
        handlerTokenExpired();
      } else {
        return { status: _get(error.response, "status", ""), message: _get(error.response.data, "message", "") };
      };
    };
  };
};